export enum OtpType {
	SIGNUP_OTP = "signup_otp",
	PASSWORD_OTP = "password_otp",
}